import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
var dragItemKey;
var sourceCls;
var COUNT = Symbol('count');
var serialName = 'jmtd-data-drag-key';

function getTarget(classname, node) {
  var target = node;

  while (target && !target.classList.contains(classname)) {
    target = target.parentNode;
  }

  return target;
}

function setDragCls(_ref) {
  var target = _ref.target,
      type = _ref.type,
      serialName = _ref.serialName;
  var from = dragItemKey;
  var to = target.getAttribute(serialName);
  var cls;

  if (from === to) {
    cls = '';
  } else if (from > to) {
    cls = 'jmtd-drop-from-more-than-to';
  } else {
    cls = 'jmtd-drop-from-less-than-to';
  }

  cls && target.classList[type](cls);
}

export default function Drag(_ref2) {
  var _dragProps;

  var onChange = _ref2.onChange,
      className = _ref2.className,
      serial = _ref2.serial,
      children = _ref2.children,
      disabled = _ref2.disabled;
  var dragProps = (_dragProps = {
    draggable: true,
    className: className
  }, _defineProperty(_dragProps, serialName, serial), _defineProperty(_dragProps, "onDragStart", function onDragStart(e) {
    sourceCls = className;
    dragItemKey = e.target.getAttribute(serialName);
    e.target.style.opacity = 0.5;
    e.dataTransfer.effectAllowed = 'move';
    e.stopPropagation();
  }), _defineProperty(_dragProps, "onDragEnter", function onDragEnter(e) {
    if (sourceCls === className) {
      var target = getTarget(className, e.target);
      target[COUNT] = (target[COUNT] || 0) + 1;
      setDragCls({
        target: target,
        type: 'add',
        serialName: serialName
      });
    }
  }), _defineProperty(_dragProps, "onDragOver", function onDragOver(e) {
    e.preventDefault();
  }), _defineProperty(_dragProps, "onDragLeave", function onDragLeave(e) {
    if (sourceCls === className) {
      var target = getTarget(className, e.target);

      if (--target[COUNT] === 0) {
        setDragCls({
          target: target,
          type: 'remove',
          serialName: serialName
        });
      }
    }
  }), _defineProperty(_dragProps, "onDrop", function onDrop(e) {
    if (sourceCls === className) {
      var target = getTarget(className, e.target);
      var from = dragItemKey;
      var to = target.getAttribute(serialName);
      target[COUNT] = 0;

      if (from !== to) {
        onChange({
          from: from,
          to: to
        });
      }

      setDragCls({
        target: target,
        type: 'remove',
        serialName: serialName
      });
    }
  }), _defineProperty(_dragProps, "onDragEnd", function onDragEnd(e) {
    sourceCls = '';
    e.target.style.opacity = 1;
  }), _dragProps);
  return disabled ? children : /*#__PURE__*/React.createElement("span", dragProps, children);
}
Drag.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  serial: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired
};
Drag.defaultProps = {
  disabled: false,
  onChange: function onChange() {},
  className: 'jmtd-drag-item-wrapper'
};